export const PackageApi = Symbol.for('PackageApi');

/**
 * 套餐类型
 */
export interface IPackageType {
    end_at: string;
    eureka_package: string;
    trial_package_left_days?: number;
    product_type: string;
    package_type: 'FREE' | 'TRIAL' | 'COMMERCIAL';
}

/**
 * Package API
 * 处理用户套餐信息相关的接口调用
 */
export interface PackageApi {
    /**
     * 获取用户套餐信息
     * @returns Promise<IPackageType[]> - 返回用户套餐信息列表
     */
    getUserPackageType(): Promise<IPackageType[]>;
}
